import { render, staticRenderFns } from "./element.vue?vue&type=template&id=034b5394&scoped=true"
import script from "./element.vue?vue&type=script&lang=js"
export * from "./element.vue?vue&type=script&lang=js"
import style0 from "./element.vue?vue&type=style&index=0&id=034b5394&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "034b5394",
  null
  
)

export default component.exports